import type { ReactNode } from 'react'

/**
 * Как `renderPriorityLadder` в `frontend/src/pages/Tickets.js`: четыре столбца растущей высоты,
 * закрашенные снизу в зависимости от приоритета.
 */
const PRIORITY_LADDER: Record<
  string,
  { count: number; color: string }
> = {
  low: { count: 1, color: '#94A3B8' },
  normal: { count: 2, color: '#3B82F6' },
  high: { count: 3, color: '#F59E0B' },
  urgent: { count: 4, color: '#EF4444' },
}

export function PriorityLadder({ priority }: { priority: string | null | undefined }) {
  const key = String(priority ?? 'normal').toLowerCase()
  const config = PRIORITY_LADDER[key] ?? PRIORITY_LADDER.normal

  const bars: ReactNode[] = []
  for (let i = 1; i <= 4; i++) {
    const isFilled = i <= config.count
    const opacity = isFilled ? 1 : 0.2
    const height = 3 + i * 2
    bars.push(
      <span
        key={i}
        style={{
          display: 'inline-block',
          width: 3,
          height,
          background: config.color,
          opacity,
          verticalAlign: 'bottom',
          borderRadius: 1,
          flexShrink: 0,
        }}
      />,
    )
  }

  return (
    <div
      style={{
        display: 'inline-flex',
        alignItems: 'flex-end',
        gap: 2,
        height: 14,
        verticalAlign: 'middle',
        justifyContent: 'center',
        lineHeight: 0,
      }}
    >
      {bars}
    </div>
  )
}
